/* Native Tilvy price/gallery foundation scoped across independent sections; native FormData purchase contract unchanged. */
(function () { if(window.tilvySplitBuybox)return;var mounts=new Map(),queued=false;
function mount(root){var productId=root.dataset.tvBuyboxProduct,UID='tv-'+productId;var parts=Array.from(document.querySelectorAll('[data-tv-buybox-product="'+productId+'"]'));var nodes=parts.flatMap(function(part){return [part].concat(Array.from(part.querySelectorAll('input,select,textarea,button,[data-pb-tiers],[data-pb-ptype],[data-pb-options],[data-pb-rail]')));});var previous=mounts.get(productId);if(previous&&previous.nodes.length===nodes.length&&previous.nodes.every(function(node,index){return node===nodes[index];}))return;if(previous)previous.abort.abort();var abort=new AbortController();mounts.set(productId,{abort:abort,nodes:nodes});
    var cur = root.dataset.cur || '€';
    // FIX "store defaulted to EUR": when Shopify Markets/Currency is active (buyer context
    // exposes window.Shopify.currency.active, e.g. 'GBP' under UK), fmt() formats in the REAL
    // active currency -> no more hardcoded '€' on tier switch. Fallback (no Markets currency in
    // context, e.g. a bare section preview with no bound product) stays as before.
    var shopCur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
    var fmt = function (n) {
      if (shopCur) {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: shopCur }).format(n); } catch (e) {}
      }
      return n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + cur;
    };
    var qa = function (s, r) { return r ? Array.from(r.querySelectorAll(s)) : Array.from(document.querySelectorAll('[data-tv-buybox-product="' + productId + '"]')).flatMap(function (part) { return Array.from(part.querySelectorAll(s)); }).filter(function (el,index,all) { return all.indexOf(el) === index; }); };
    var q = function (s, r) { return qa(s,r)[0] || null; };
    var listen = function (el,event,callback,options) { if (el) el.addEventListener(event,callback,Object.assign({},options || {},{signal:abort.signal})); };

    var grind = '';
    var firstOpt = q('[data-pb-opt]'); if (firstOpt) grind = firstOpt.getAttribute('data-pb-opt');
    var tier = q('[data-pb-tier].is-sel') || q('[data-pb-tier]');

    function tierTotal(t) { var u = parseFloat(t.dataset.unit) || 0, m = parseInt(t.dataset.mult) || 1, d = parseFloat(t.dataset.disc) || 0; return u * m * (1 - d); }
    function tierFull(t) { var u = parseFloat(t.dataset.unit) || 0, m = parseInt(t.dataset.mult) || 1; return u * m; }

    // Per-tier price labels
    qa('[data-pb-tier]').forEach(function (t) { var el = q('[data-pb-tier-price]', t); if (el) el.textContent = fmt(tierTotal(t)); });

    function planFactor(){ var r=q('[data-pb-ptype] input:checked'); return r?(parseFloat(r.dataset.pbFactor)||1):1; }
    function sync() {
      if (!tier) return;
      var pf = planFactor();
      var total = tierTotal(tier) * pf, full = tierFull(tier), disc = parseFloat(tier.dataset.disc) || 0;
      if (pf < 1) disc = 1 - pf;
      qa('[data-pb-price]').forEach(function (e) { e.textContent = fmt(total); });
      qa('[data-pb-atc-price]').forEach(function (e) { e.textContent = fmt(total); });
      qa('[data-pb-satc-price]').forEach(function (e) { e.textContent = fmt(total); });
      var old = q('[data-pb-old]'), save = q('[data-pb-save]');
      // Subscription strike-price vs. Trial compare-at: never shown at the same time (no stacked
      // discounts). disc>0 here means exclusively "Subscribe & Save is active" (tiers always carry
      // data-disc="0", the discount comes only from planFactor) -> the trial strike-price/badge
      // hide, the subscription strike-price/save take over; otherwise the reverse. Trial compare
      // (Sven 2026-07-22): reads the REAL per-tier data-compare attribute (set server-side only on
      // the Trial card, only when launch_offer_enabled) instead of the old universal /0.85 anchor
      // fiction -- absent/blank on any other tier, so it just stays hidden there.
      var lOld = q('[data-pb-launch-old]'), lBadge = q('[data-pb-launch-badge]');
      var compare = parseFloat(tier.dataset.compare);
      if (disc > 0) {
        if (old) { old.hidden = false; old.textContent = fmt(full); }
        if (save) { save.hidden = false; save.textContent = '−' + Math.round(disc * 100) + ' %'; }
        if (lOld) lOld.hidden = true;
        if (lBadge) lBadge.hidden = true;
      } else {
        if (old) old.hidden = true;
        if (save) save.hidden = true;
        if (lOld) { if (!isNaN(compare)) { lOld.hidden = false; lOld.textContent = fmt(compare); } else { lOld.hidden = true; } }
        if (lBadge) lBadge.hidden = isNaN(compare);
      }
      // Purchase-type "Subscribe & Save" subline (Sven 2026-07-22): was a static SSR string tied to
      // whichever variant was selected at page load -- now follows tier switches too (e.g. Trial
      // £19.95 -> £15.96/mo, Standard £39.95 -> £31.96/mo), reading the Subscribe
      // radio's factor regardless of which purchase-type is currently checked.
      var ptypeSub = q('[data-pb-ptype-sub]');
      if (ptypeSub) {
        var spInput = q('[data-pb-ptype] input[value]:not([value=""])');
        var spFactor = spInput ? (parseFloat(spInput.dataset.pbFactor) || 1) : 1;
        ptypeSub.textContent = fmt(tierTotal(tier) * spFactor) + ' pro Box · monatlich · jederzeit kündbar';
      }
      // J-FIX: Subscribe & Save toggle stays hidden while the Trial tier is selected (Trial is
      // one-off by definition, see markup comment above the ptype block for the full rationale).
      var ptypeWrap = q('[data-pb-ptype]'), ptypeLabel = q('.pl-pb__optlabel--ptype');
      if (ptypeWrap) {
        var hideForTrial = !!(tier && tier.dataset.trial === '1');
        ptypeWrap.hidden = hideForTrial;
        if (ptypeLabel) ptypeLabel.hidden = hideForTrial;
      }
    }

    // Purchase type (subscription)
    var ptype = q('[data-pb-ptype]');
    if (ptype) listen(ptype,'change', function(){ qa('[data-pb-ptype] .pl-pb__tier').forEach(function(x){var r=q('input',x); x.classList.toggle('is-sel', !!(r&&r.checked));}); sync(); });
    // Tiers
    var tiers = q('[data-pb-tiers]');
    if (tiers) listen(tiers,'click', function (e) {
      var t = e.target.closest('[data-pb-tier]'); if (!t) return;
      // Guard (Sven 2026-07-22): a <label>-click still bubbles even when its wrapped radio is
      // disabled (e.g. the Trial card while Trial is out of stock) -- without this check the price
      // display could visually "select" a variant that never actually got checked, a silent
      // price-vs-cart mismatch. Backed up by CSS pointer-events:none on .pl-pb__tier--disabled too.
      var tIn = q('input', t); if (tIn && tIn.disabled) return;
      qa('[data-pb-tier]').forEach(function (x) { x.classList.remove('is-sel'); });
      t.classList.add('is-sel'); tier = t;
      // J-FIX: Trial is one-off by definition -- force Subscribe & Save back to "One-time" the
      // moment the Trial tier is selected, so the form can never submit "id=Trial +
      // selling_plan=X" (would silently create a subscription on a one-off trial offer).
      if (t.dataset.trial === '1') {
        var oneTime = q('[data-pb-ptype] input[value=""]');
        if (oneTime && !oneTime.checked) {
          oneTime.checked = true;
          qa('[data-pb-ptype] .pl-pb__tier').forEach(function (x) { var r = q('input', x); x.classList.toggle('is-sel', !!(r && r.checked)); });
        }
      }
      sync();
      showVariantImage(t);
    });
    // Options (grind/variant)
    var opts = q('[data-pb-options]');
    if (opts) listen(opts,'click', function (e) {
      var b = e.target.closest('[data-pb-opt]'); if (!b) return;
      qa('[data-pb-opt]').forEach(function (x) { x.classList.remove('is-sel'); });
      b.classList.add('is-sel'); grind = b.getAttribute('data-pb-opt');
    });
    // Editorial Night Rail (mobile): Dots + Caption folgen dem Scroll — re-runnable via initPb
    var rail = q('[data-pb-rail]');
    if (rail) {
      var slides = qa('[data-pb-slide]', rail);
      var dots = qa('[data-pb-dots] i');
      var cap = q('[data-pb-cap]');
      var railUpd = function () {
        if (!slides.length) return;
        var w = slides[0].offsetWidth + 10;
        var i2 = Math.min(slides.length - 1, Math.max(0, Math.round(rail.scrollLeft / w)));
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i2); });
        if (cap) cap.textContent = (i2 + 1) + '/' + slides.length + (slides[i2].dataset.caption ? ' · ' + slides[i2].dataset.caption : '');
      };
      listen(rail,'scroll', function () { requestAnimationFrame(railUpd); }, { passive: true });
      railUpd();
    }
    // Gallery
    function showGalleryImage(data, selectedThumb) {
      var main = q('#pl-pb-main-' + UID);
      if (main) {
        main.src = data.src;
        main.alt = data.alt || '';
        if (data.width) main.setAttribute('width', data.width);
        if (data.height) main.setAttribute('height', data.height);
        // Info-Slides are native 4:5, not square -- swap the main viewer box to match so the
        // full infographic shows (see .pl-pb__main.is-info), same zero-crop trick as the mobile rail.
        var mainWrap = main.closest('.pl-pb__main');
        if (mainWrap) mainWrap.classList.toggle('is-info', data.kind === 'info');
      }
      var thumbs = qa('[data-pb-thumb]');
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === selectedThumb); });
      var fact = q('.pl-pb__fact'); if (fact) fact.style.display = selectedThumb && selectedThumb === thumbs[0] ? '' : 'none'; // Pill gehoert zum Hero-Slot
    }
    qa('[data-pb-thumb]').forEach(function (b) { listen(b,'click', function () {
      showGalleryImage(Object.assign({}, b.dataset, {alt: b.dataset.alt || b.getAttribute('aria-label') || ''}), b);
    }); });
    // Only tiers explicitly carrying Shopify variant media opt in. Purchase inputs stay native.
    function showVariantImage(t) {
      if (!t || !t.dataset.pbVariantSrc) return;
      var thumb = qa('[data-pb-thumb]').find(function (b) { return b.dataset.pbImageId === t.dataset.pbImageId; });
      showGalleryImage({src:t.dataset.pbVariantSrc,alt:t.dataset.pbVariantAlt,width:t.dataset.pbVariantWidth,height:t.dataset.pbVariantHeight}, thumb);
    }
    if (tiers) listen(tiers,'change', function (event) {
      var input = event.target, t = input.closest('[data-pb-tier]');
      if (input.name !== 'id' || !input.checked || input.disabled || !t || !t.dataset.pbVariantSrc) return;
      qa('[data-pb-tier]').forEach(function (x) { x.classList.toggle('is-sel', x === t); });
      tier = t; sync(); showVariantImage(t);
    });

    // ADD-TO-CART = native form submit. The tier <label>s contain real <input type="radio"
    // name="id"/"quantity" form="pl-bf-tv-stable-product"> — the radios ARE the form controls, so selecting a tier
    // sets the submitted variant/quantity natively. ATC + sticky-ATC are <button type="submit"
    // form="pl-bf-tv-stable-product">. ONE add path, server-side, lands on /cart. No JS reads/writes the form, no
    // fetch, no /cart/add.js, no cart array, no drawer, no mock — nothing here can swallow an add.

    // Sticky mobile ATC: show when the inline ATC scrolls out of view (page-length independent)
    var satc = q('[data-pb-satc]');
    var mainAtc = q('[data-pb-atc-main]');
    var stickyUpd = function () { if (satc && mainAtc) satc.classList.toggle('is-show', mainAtc.getBoundingClientRect().bottom < 0); };
    if (satc && mainAtc && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(stickyUpd, { threshold: 0 }); stickyObserver.observe(mainAtc); abort.signal.addEventListener('abort',function () { stickyObserver.disconnect(); },{once:true});
      listen(window,'scroll', stickyUpd, { passive: true });
    } else if (satc) {
      listen(window,'scroll', stickyUpd, { passive: true });
    }
    stickyUpd();

    sync();

}
function boot() {
  queued = false;
  window.tilvyProductInfoGroup?.reconcile();
  var roots = Array.from(document.querySelectorAll('[data-tv-gallery-for]'));
  mounts.forEach(function (state,id) {
    if (!roots.some(function (root) { return root.dataset.tvBuyboxProduct === id; })) {
      state.abort.abort(); mounts.delete(id);
    }
  });
  roots.forEach(mount);
  document.querySelectorAll('[data-tv-buybox-product] [data-pb-atc]').forEach(function (button) {
    var part = button.closest('[data-tv-buybox-product]'), id = part.dataset.tvBuyboxProduct;
    var forms = document.querySelectorAll('form[id="' + button.getAttribute('form') + '"]');
    var gallery = roots.find(function (root) { return root.dataset.tvBuyboxProduct === id; });
    var partCount = function (kind) {
      return document.querySelectorAll('[data-tv-buybox-product="' + id + '"][data-tv-buybox-part="' + kind + '"]').length;
    };
    // Removing a required purchase section must not bypass its now-absent native fields.
    var missingRequiredPart = ['selection','personalization','purchase'].some(function (kind) { return partCount(kind) !== 1; });
    var duplicates = ['extras','bonuses'].some(function (kind) { return partCount(kind) > 1; });
    var variantControls = forms.length === 1 ? Array.from(forms[0].elements).filter(function (input) {
      return input.name === 'id' && !input.disabled && (input.type !== 'radio' || input.checked);
    }) : [];
    if (forms.length !== 1 || !gallery || missingRequiredPart || duplicates || variantControls.length !== 1) {
      button.disabled = true; button.dataset.tvMissingForm = 'true';
    } else if (button.dataset.tvMissingForm) {
      delete button.dataset.tvMissingForm;
      button.disabled = gallery.dataset.tvAvailable !== 'true';
    }
  });
}
function schedule(){if(queued)return;queued=true;queueMicrotask(boot);}window.tilvySplitBuybox={boot:schedule};['shopify:section:load','shopify:section:reorder','shopify:section:unload','tilvy:info-group:change'].forEach(function(event){document.addEventListener(event,schedule);});window.addEventListener('pageshow',schedule);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();})();
